<template>
  <div class="login">
    <img alt="Book it logo" src="../assets/bookit_logo.png" style="width: 15rem;">
    <el-form>
      <el-form-item label="E-Mail">
        <el-input
          placeholder="E-Mail"
          v-model="form.email"
        />
      </el-form-item>
      <el-form-item label="Passwort">
        <el-input
          type="password"
          placeholder="Passwort"
          v-model="form.pwd"
          show-password
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="login()">Login</el-button>
      </el-form-item>
    </el-form>
    <p>{{ error }}</p>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      form: {
        email: '',
        pwd: ''
      },
      error: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async getToken () {
      await this.$store.dispatch('getAuthToken')
    },
    async login () {
      let self = this
      axios.get('https://us-central1-klingelplatten-360service.cloudfunctions.net/api/token/')
        .then(response => {
          console.log(response.data.access_token)
          firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.pwd).then(function (success) {
            self.$store.commit('setLoggedIn')
            self.$router.push('/select')
          }).catch(function (error) {
            var errorCode = error.code
            var errorMessage = error.message
            self.error = error
            console.log('Code: ', errorCode)
            console.log('Message: ', errorMessage)
            self.$message.error('Code: ' + errorCode + 'Message: ' + errorMessage)
          })
          return self.$store.commit('setAuth', response.data.access_token)
        })
        .catch(error => {
          console.log('Couldnt fetch APALEO token from OAuth server')
          console.log('ERROR:', error)
        })
    }
  }
}
</script>

<style scoped>

.login {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  max-width: 20em;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

</style>
